import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';

export class DetailedReportingApi extends BaseApi {
    constructor(client) { super(client, '/detailed-reports'); }

    async #request(operation) {
        try { return (await operation()).data; }
        catch (error) { throw ApiError.fromResponse(error); }
    }

    generate(data) { return this.#request(() => this.client.post(`${this.basePath}/generate`, data)); }
    getAiConfiguration(reportKey) { return this.#request(() => this.client.get(`${this.basePath}/ai/configuration`, { params: { reportKey } })); }
    listSnapshots(reportKey) { return this.#request(() => this.client.get(`${this.basePath}/snapshots`, { params: { reportKey } })); }
    compareSnapshots(baselineId, targetId) { return this.#request(() => this.client.get(`${this.basePath}/snapshots/${baselineId}/compare/${targetId}`)); }
    createComparisonSession(baselineId, targetId, data) { return this.#request(() => this.client.post(`${this.basePath}/snapshots/${baselineId}/compare/${targetId}/session`, data)); }
    deleteSnapshot(id) { return this.#request(() => this.client.delete(`${this.basePath}/snapshots/${id}`)); }
    listJobs() { return this.#request(() => this.client.get(`${this.basePath}/jobs`)); }
    createJob(data) { return this.#request(() => this.client.post(`${this.basePath}/jobs`, data)); }
    updateJob(id, data) { return this.#request(() => this.client.put(`${this.basePath}/jobs/${id}`, data)); }
    runJob(id) { return this.#request(() => this.client.post(`${this.basePath}/jobs/${id}/run`)); }
    listArchives(reportKey) { return this.#request(() => this.client.get(`${this.basePath}/archives`, { params: reportKey ? { reportKey } : {} })); }
    createDownloadLink(id) { return this.#request(() => this.client.post(`${this.basePath}/archives/${id}/download-link`)); }
    async downloadArchive(id, token) {
        try {
            const response = await this.client.get(`${this.basePath}/archives/${id}/download`, {
                params: { token },
                responseType: 'blob',
            });
            return {
                artifact: response.data,
                contentType: response.headers?.['content-type'],
                contentDisposition: response.headers?.['content-disposition'],
            };
        } catch (error) { throw ApiError.fromResponse(error); }
    }
    updateLifecycle(id, data) { return this.#request(() => this.client.put(`${this.basePath}/archives/${id}/lifecycle`, data)); }
    listNarratives(snapshotId) { return this.#request(() => this.client.get(`${this.basePath}/narratives`, { params: { snapshotId } })); }
    generateNarrative(data) { return this.#request(() => this.client.post(`${this.basePath}/narratives`, data)); }
    regenerateNarrative(id) { return this.#request(() => this.client.post(`${this.basePath}/narratives/${id}/regenerate`)); }
    updateNarrative(id, data) { return this.#request(() => this.client.put(`${this.basePath}/narratives/${id}`, data)); }
    deleteNarrative(id) { return this.#request(() => this.client.delete(`${this.basePath}/narratives/${id}`)); }
}
